import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Register = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'customer', phone: '', city: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.register(form);
     navigate('/verify-email', { state: { email: form.email } });
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-brand">
          <div className="auth-logo">SS</div>
          <h2>SmartService</h2>
        </div>
        <h1>Join SmartService Today</h1>
        <p>Whether you need a service or offer one — SmartService connects you with the right people.</p>
        <div className="auth-features">
          <div className="auth-feature">🏠 Book home services instantly</div>
          <div className="auth-feature">💰 Earn money as a provider</div>
          <div className="auth-feature">⭐ Read real reviews</div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-form-box">
          <h2>Create your account</h2>
          <p className="auth-sub">Join thousands of users today</p>

          {error && <div className="auth-error">⚠️ {error}</div>}

          <div className="role-selector">
            <button
              type="button"
              className={`role-btn ${form.role === 'customer' ? 'active' : ''}`}
              onClick={() => setForm({ ...form, role: 'customer' })}
            >🏠 I need services</button>
            <button
              type="button"
              className={`role-btn ${form.role === 'provider' ? 'active' : ''}`}
              onClick={() => setForm({ ...form, role: 'provider' })}
            >🔧 I provide services</button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" placeholder="Muhammad Ali" value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input type="tel" placeholder="03xx-xxxxxxx" value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              </div>
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="your@email.com" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City</label>
                <select value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })}>
                  <option value="">Select City</option>
                  {['Islamabad', 'Rawalpindi', 'Lahore', 'Karachi', 'Peshawar', 'Quetta', 'Multan', 'Faisalabad'].map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" placeholder="Min 6 characters" value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} />
              </div>
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          <p className="auth-switch">
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
